export const AUTH_SESSION_STORAGE_KEY = 'expresserp.auth.session';
export const AUTH_REMEMBERED_USERNAME_KEY = 'expresserp.auth.remembered-username';

export interface AuthSession {
    accessToken: string;
    expiresAt: number;
    rememberMe: boolean;
}

export function readAuthSession(): AuthSession | null {
    const remembered = parseSession(localStore().getItem(AUTH_SESSION_STORAGE_KEY));
    if (remembered && !isExpired(remembered)) {
        return remembered;
    }

    const currentTab = parseSession(sessionStore().getItem(AUTH_SESSION_STORAGE_KEY));
    if (currentTab && !isExpired(currentTab)) {
        return currentTab;
    }

    if (remembered) {
        localStore().removeItem(AUTH_SESSION_STORAGE_KEY);
    }
    if (currentTab) {
        sessionStore().removeItem(AUTH_SESSION_STORAGE_KEY);
    }
    return null;
}

export function persistAuthSession(session: AuthSession, username: string): void {
    const serialized = JSON.stringify(session);
    if (session.rememberMe) {
        localStore().setItem(AUTH_SESSION_STORAGE_KEY, serialized);
        localStore().setItem(AUTH_REMEMBERED_USERNAME_KEY, username);
        sessionStore().removeItem(AUTH_SESSION_STORAGE_KEY);
        return;
    }

    sessionStore().setItem(AUTH_SESSION_STORAGE_KEY, serialized);
    localStore().removeItem(AUTH_SESSION_STORAGE_KEY);
    localStore().removeItem(AUTH_REMEMBERED_USERNAME_KEY);
}

export function clearAuthSession(): void {
    localStore().removeItem(AUTH_SESSION_STORAGE_KEY);
    sessionStore().removeItem(AUTH_SESSION_STORAGE_KEY);
}

export function readRememberedUsername(): string | null {
    const username = localStore().getItem(AUTH_REMEMBERED_USERNAME_KEY);
    return username && username.trim().length > 0 ? username : null;
}

function localStore(): Storage {
    return window.localStorage;
}

function sessionStore(): Storage {
    return window.sessionStorage;
}

function parseSession(raw: string | null): AuthSession | null {
    if (!raw) {
        return null;
    }
    try {
        const parsed = JSON.parse(raw) as Partial<AuthSession>;
        if (typeof parsed.accessToken !== 'string' || parsed.accessToken.length === 0) {
            return null;
        }
        if (typeof parsed.expiresAt !== 'number' || !Number.isFinite(parsed.expiresAt)) {
            return null;
        }
        return {
            accessToken: parsed.accessToken,
            expiresAt: parsed.expiresAt,
            rememberMe: parsed.rememberMe === true
        };
    } catch {
        return null;
    }
}

function isExpired(session: AuthSession): boolean {
    return session.expiresAt <= Date.now();
}
